require('expose-loader?jQuery!jquery');
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'swiper/swiper-bundle.js'

let brainCommon = require('./modules/brain-common');

let brainSwiper = require('./modules/brain-swiper');
let brainImageSwiper = require('./modules/brain-image-slider');
let brainCookieConsent = require('./modules/cookieconsent');
let brainLightBox = require('./modules/lightbox');
require(['jquery'], function($) {
    $(document).ready(function () {
        brainLightBox.init('#content-wrap');
        brainLightBox.initImageSourceBox();
        $( window ).on( "load", function() {
            $('.slider-outer-wrapper').each(function(){
                let currentWrapper = $(this);
                brainSwiper.create(currentWrapper);
            });
        });

        $('.image-swiper-container').each(function(){
        brainImageSwiper.create($(this));
        });

        brainCookieConsent.init();
        brainCommon.menuScroller();
        brainCommon.initBackgroundImages();
        brainCommon.initForm();
        brainCommon.initBreadcrumb();
        brainCommon.initHeader();
    });
});
